export interface AuthenticatorEntry {
  id: string
  name: string
  issuer?: string
  account?: string
  secret?: string // Only present when unlocked
  encryptedSecret?: string // Only present when locked
  isLocked: boolean
  lockId?: string // Quest lock ID when locked
  createdAt: number
  lockedAt?: number
}

export interface AuthenticatorCode {
  id: string
  name: string
  issuer?: string
  account?: string
  code: string
  remainingTime: number
  isLocked: boolean
}

export interface QRCodeData {
  issuer?: string
  account?: string
  secret: string
}

export interface AuthenticatorLockRequest {
  name: string
  secret: string
  quests: any[] // Will use Quest type from existing system
  difficulty: string
  threshold: number
  totalShares: number
}

export interface AuthenticatorStorage {
  version: number
  authenticators: AuthenticatorEntry[]
  lastUpdated: number
}

export interface AuthenticatorStats {
  total: number
  locked: number
  unlocked: number
}

export const AUTHENTICATOR_DB_NAME = 'quest-lock-authenticator'
export const AUTHENTICATOR_DB_VERSION = 1
export const AUTHENTICATOR_STORE_NAME = 'authenticators'
